export default __webpack_public_path__ + "static/media/jellyfish.b28206dd5adaf934faf766bc4c12b5c6.png";